import React from 'react';

const BOLD_MARKER = /<bold>(.*?)<\/bold>/g;

// Renders <bold>…</bold> markers from a translated string as bold text. Everything else, including
// interpolated values, stays a plain text node, so nothing in the string is ever treated as HTML.
const BoldText = ({ text }: { text: string }) => {
    const nodes: React.ReactNode[] = [];
    let last = 0;

    Array.from(text.matchAll(BOLD_MARKER)).forEach((match) => {
        if (match.index > last) nodes.push(text.slice(last, match.index));
        nodes.push(<b key={match.index}>{match[1]}</b>);
        last = match.index + match[0].length;
    });
    if (last < text.length) nodes.push(text.slice(last));

    return <>{nodes}</>;
};

export default BoldText;
